import { render } from "./DashboardAccumulatedGoal.vue?vue&type=template&id=04b37635&scoped=true&ts=true"
import script from "./DashboardAccumulatedGoal.vue?vue&type=script&lang=ts"
export * from "./DashboardAccumulatedGoal.vue?vue&type=script&lang=ts"

import "./DashboardAccumulatedGoal.vue?vue&type=style&index=0&id=04b37635&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b37635"]])

export default __exports__